/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_PLANETARY_RESULT,
	GET_PLANETARY_RESULT_SUCCESS,
	GET_PLANETARY_RESULT_ERROR,
	RESET_PLANETARY_RESULT,
} from "@/stores/actions/WindDiagnosticPlanetaryResult";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status: FetchStatus.Init,
	data:   {
		sunStatus:        0,
		planetStatus:     0,
		ringStatus:       0,
		signalSettingIds: []
	},
	error: {},
};

const actions = {
	[GET_PLANETARY_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_PLANETARY_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/Planetary`)
			.then((resp) =>
			{
				commit(GET_PLANETARY_RESULT_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_PLANETARY_RESULT_ERROR, error.response);
			});
	},

	[RESET_PLANETARY_RESULT]: ({ commit }) =>
	{
		commit(RESET_PLANETARY_RESULT);
	},
};

const mutations = {
	[GET_PLANETARY_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_PLANETARY_RESULT_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.data = data;
	},
	[GET_PLANETARY_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_PLANETARY_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.data.sunStatus = DiagnosticRange.undefined;
		state.data.planetStatus = DiagnosticRange.undefined;
		state.data.cageStatus = DiagnosticRange.undefined;
	},
};

export default {
	state,
	actions,
	mutations,
};
